import React from "react";

import { useFromPage } from "../../providers/FromPageProvider";
import { SideSheetProvider } from "../../providers/SideSheetProvider/SideSheetProvider";

import { EventSeatMapWrapper } from "./EventSeatMapWrapper";
import { GroupTicketsSeatMapWrapper } from "./GroupTicketsSeatMapWrapper";

export default function SeatMapWrapper({
  eventId,
  groupTicketsId,
  offerId,
  assignTicketType,
}) {
  const { isAssigningTickets } = useFromPage();

  return (
    <>
      {isAssigningTickets ? (
        <SideSheetProvider>
          <GroupTicketsSeatMapWrapper
            eventId={eventId}
            id={groupTicketsId}
            ticketType={assignTicketType}
          />
        </SideSheetProvider>
      ) : (
        <EventSeatMapWrapper eventId={eventId} offerId={offerId} />
      )}
    </>
  );
}
